import { Button, ControlledInput } from "@dune/ui";
import { Minus, Plus } from "lucide-react";
import { useFieldArray, useFormContext } from "react-hook-form";
import AddressFormFields from "../../shared/AddressFormFields";
import { CreateConstructionSiteClientFormData } from "./useCreateConstructionSiteForm";

const MAX_USERS = 2;

const NewClientUserForm = () => {
	const { control, formState } =
		useFormContext<CreateConstructionSiteClientFormData>();
	const { errors } = formState;

	const { fields, append, remove } = useFieldArray({
		control,
		name: "clientUsers",
	});

	const addUser = () => {
		if (fields.length < MAX_USERS) {
			append({
				firstname: "",
				lastname: "",
				email: "",
				streetNumber: "",
				streetName: "",
				postalCode: "",
				city: "",
			});
		}
	};

	const removeUser = (index: number) => {
		if (fields.length > 1) {
			remove(index);
		}
	};

	return (
		<div className="flex flex-col gap-6 w-full">
			{fields.map((field, index) => (
				<div key={field.id} className="flex flex-col gap-4 w-full">
					<div className="flex flex-row justify-between items-center">
						<h3 className="text-lg font-medium text-[#144C65]">
							{fields.length > 1 ? `Client ${index + 1}` : "Client"}
						</h3>
						{fields.length > 1 && (
							<Button
								onClick={() => removeUser(index)}
								variant="none"
								size="none"
								className="self-start"
								type="button"
							>
								<div className="flex flex-row items-center gap-2 font-medium text-sm text-red-600">
									<Minus /> Supprimer
								</div>
							</Button>
						)}
					</div>

					<div className="flex flex-row gap-4 w-full">
						<ControlledInput
							control={control}
							name={`clientUsers.${index}.lastname`}
							label="Nom"
							error={
								"clientUsers" in errors
									? errors.clientUsers?.[index]?.lastname?.message?.toString()
									: undefined
							}
						/>
						<ControlledInput
							control={control}
							name={`clientUsers.${index}.firstname`}
							label="Prénom"
							error={
								"clientUsers" in errors
									? errors.clientUsers?.[index]?.firstname?.message?.toString()
									: undefined
							}
						/>
					</div>

					<ControlledInput
						control={control}
						name={`clientUsers.${index}.email`}
						label="Email"
						error={
							"clientUsers" in errors
								? errors.clientUsers?.[index]?.email?.message?.toString()
								: undefined
						}
					/>

					<AddressFormFields
						fieldPrefix={`clientUsers.${index}`}
						includeGeolocation={false}
					/>

					{index < fields.length - 1 && (
						<div className="border-b border-gray-200 pt-2" />
					)}
				</div>
			))}

			{fields.length < MAX_USERS && (
				<Button
					onClick={addUser}
					variant="none"
					size="none"
					className="self-start"
					type="button"
				>
					<div className="flex flex-row items-center gap-2 font-medium text-sm text-primary">
						<Plus /> Ajouter
					</div>
				</Button>
			)}
		</div>
	);
};

export default NewClientUserForm;
